import { FALLBACK_SVG } from '../constants';

/**
 * Builds a list of image URLs from a comma-separated string.
 * Falls back to the image saved on the deal's vehicle when no URL is provided or parsing fails,
 * and to the greyed-out SVG placeholder when the deal has no image either.
 *
 * @param imageUrls - Comma-separated image URLs or undefined
 * @param dealVehicleImage - Image saved on the deal's vehicle, if any
 * @returns Array of image URLs, at minimum containing the fallback SVG
 *
 */
export const buildImageList = (imageUrls: string | undefined, dealVehicleImage?: string): string[] => {
    const fallbackImage = dealVehicleImage?.trim() || FALLBACK_SVG;

    if (!imageUrls || imageUrls.trim().length === 0) {
        return [fallbackImage];
    }

    const images = imageUrls
        .split(',')
        .map((url) => url.trim())
        .filter(Boolean);

    return images.length > 0 ? images : [fallbackImage];
};
